<!--
  ~ Copyright (C) 2019 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="polar-chart">
  <div [id]="'chart' + chartId" class="hidden-aria-labels">
    <span>{{ 'translations.assessmentReportChartTitle' | transloco }}</span>
    <span *ngFor="let title of chartDataLabels; index as i">
      {{ 'translations.assessmentReportChartItem' | transloco }} {{ title }}, {{ 'translations.assessmentReportChartScore' | transloco }}
      {{ chartData[0].data[i] }}.
    </span>
  </div>

  <div class="chart-container">
    <canvas
      #Chart
      baseChart
      [datasets]="chartData"
      [labels]="chartDataLabels"
      [plugins]="chartPlugins"
      [type]="'polarArea'"
      [options]="chartOptions"
    ></canvas>

    <div class="user-image" *ngIf="(userDetailsData$ | async)?.imageUrl">
      <img [src]="(userDetailsData$ | async)?.imageUrl" alt="{{ (userDetailsData$ | async)?.firstName }}" width="60" height="60" />
    </div>
    <div class="user-no-image" *ngIf="!(userDetailsData$ | async)?.imageUrl">
      {{ (userDetailsData$ | async)?.firstName[0] }}
    </div>
  </div>

  <div #circlePoints class="circle">
    <div
      class="point f_point"
      *ngFor="let sectionItem of chartSectionItems; let i = index"
      (click)="scrollTo(sectionItem.sectionUid)"
      (keydown.enter)="scrollTo(sectionItem.sectionUid)"
      [style.border-bottom-color]="chartDataAlphaColors[i]"
    >
      <span>
        {{ sectionItem.title }}
      </span>
    </div>
  </div>
  <div #circleLines class="circle circle-1"></div>

  <div class="polar-chart-labels" *ngIf="!!chartData?.length">
    <div class="key" *ngFor="let item of chartDataLabels; let i = index">
      <div [style.backgroundColor]="chartDataAlphaColors[i]"></div>
      <div class="small">{{ chartDataLabels[i] }}</div>
    </div>
  </div>
</div>
